import f3tch from 'f3tch';

import profile from '../../api/profiles/json.profile.api';

export default () =>
  f3tch('/crm/opened_ticket_count_for_ops_user/')
    .profile(profile())
    .get();
